import React from "react";
import { Button, CompanyPage } from "../../../components/common";
// import { getCurrentTab } from "../../../utils/helper";

interface ActionProps {
  handleClick: (type: string, text?: string) => any;
  handleAdminDetailModal: (id: number) => any;
  showDetail: boolean;
  /** When false, hides the “All” tab (e.g. no admins loaded yet). */
  hasAdminList: boolean;
}

const Actions = (props: ActionProps) => {
  const { handleClick } = props;
  // const { innerTab } = useSelector(({ company }: any) => company);

  // const currentSubTab = getCurrentTab(props, true);

  // const activeTab = _.isEmpty(innerTab)
  //   ? _.isUndefined(currentSubTab)
  //     ? "All"
  //     : currentSubTab
  //   : innerTab;
  // const checktab = activeTab.toLowerCase();

  return (
    <CompanyPage.HeaderRight>
      <Button className="text-uppercase" onClick={() => handleClick("Add")}>
        Add New
      </Button>
    </CompanyPage.HeaderRight>
  );
};

export default Actions;
